module.exports = __webpack_public_path__ + "img/appAsset-bankingLogo__cl_banco_scotiabank.c7221994.svg";